/*eslint no-unused-vars: ["off"]*/
/*eslint eqeqeq: ["off"]*/
/*eslint jsx-a11y/alt-text: ["off"]*/
/*eslint jsx-a11y/anchor-is-valid: ["off"]*/
/*eslint  array-callback-return: ["off"]*/
/*eslint  react-hooks/exhaustive-deps: ["off"]*/
import actions from './actions';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import axios from 'axios';
import siteConfig from '@iso/config/site.config';
import notification from '@iso/components/Notification';

const onCallReqeust = async (URI) =>
  await axios
    .get(URI)
    .then((res) => res)
    .catch((error) => error);
const onPostCallReqeust = async (sendData, URI) =>
  await axios
    .post(URI, sendData)
    .then((res) => res)
    .catch((error) => error);
const onPutCallReqeust = async (sendData, URI) =>
  await axios
    .put(URI, sendData)
    .then((res) => res)
    .catch((error) => error);
const onDeleteCallReqeust = async (URI) =>
  await axios
    .delete(URI)
    .then((res) => res)
    .catch((error) => error);

export function* getContact() {
  try {
    const callResult = yield call(
      onCallReqeust,
      `${siteConfig.apiUrl}/tripleseatcontact`
    );
    yield put({
      type: actions.GET_CONTACT_REDUCER,
      contacts: callResult.data.results, //createDemoData(),
    });
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}

export function* addContact({ payload }) {
  try {
    const callResult = yield call(
      onPostCallReqeust,
      payload.sendData,
      `${siteConfig.apiUrl}/tripleseatcontact`
    );
    notification('success', 'Create Successfully!');
    yield put({
      type: actions.ADD_CONTACT,
      payload: { id: payload.sendData.account_id },
    });
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}

export function* getByIdContact({ payload }) {
  try {
    const callResult = yield call(
      onCallReqeust,
      `${siteConfig.apiUrl}/tripleseatcontact/${payload.id}`
    );
    yield put({
      type: actions.GET_BY_ID_CONTACT_REDUCER,
      contacts: callResult, //createDemoData(),
    });
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}

export function* updateData({ payload }) {
  try {
    const callResult = yield call(
      onPutCallReqeust,
      payload.sendData,
      `${siteConfig.apiUrl}/tripleseatcontact/${payload.id}`
    );
    notification('success', 'Update Successfully');
    yield put({
      type: actions.UPDATE_SUCCESS,
      payload: { id: payload.sendData.account_id },
    });
  } catch (error) {
    notification('error', 'Server Internal error!');
  }
}

export function* deleteData({ payload }) {
  try {
    const callResult = yield call(
      onDeleteCallReqeust,
      payload.sendData,
      `${siteConfig.apiUrl}/tripleseatcontact/${payload.id}`
    );
    notification('success', 'Delete Successfully');
    yield put({
      type: actions.DELETE_SUCCESS,
    });
  } catch (error) {
    notification('error', 'Server Internal error!');
  }
}

export default function* rootSaga() {
  yield all([yield takeEvery(actions.GET_CONTACT, getContact)]);
  yield all([yield takeEvery(actions.ADD_CONTACT, addContact)]);
  yield all([yield takeEvery(actions.UPDATE_CONTACT, updateData)]);
  yield all([yield takeEvery(actions.DELETE_CONTACT, deleteData)]);
  yield all([yield takeEvery(actions.GET_BY_ID_CONTACT, getByIdContact)]);
}
